"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceInstanceIdDetector = exports.processDetector = exports.osDetector = exports.hostDetector = void 0;
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
var node_1 = require("./node");
Object.defineProperty(exports, "hostDetector", { enumerable: true, get: function () { return node_1.hostDetector; } });
Object.defineProperty(exports, "osDetector", { enumerable: true, get: function () { return node_1.osDetector; } });
Object.defineProperty(exports, "processDetector", { enumerable: true, get: function () { return node_1.processDetector; } });
Object.defineProperty(exports, "serviceInstanceIdDetector", { enumerable: true, get: function () { return node_1.serviceInstanceIdDetector; } });
//# sourceMappingURL=index.js.map